export default  {
  bindings: {
    discounts: '<',
  },
  controller: 'discountListController',
  template: require('../views/discount.list.html')
};




// WEBPACK FOOTER //
// ./frontend/admin/app/modules/discounts/components/discount.list.component.js